import React, { useState } from "react";
import Input from "../../../Elements/Input";
import Button from "../../../Elements/Button";
import { csrfToken } from "../../../../utils/csrfTokenUtils";
import { networkService } from "../../../config/axios";
import { Col, Row } from "react-bootstrap";

const CreateNewKdf = ({ props }) => {
  const [formDocTitle, setFormDocTitle] = useState("");
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const handleSubmit = async (e) => {
    e.preventDefault(); 
    if (formDocTitle.trim() === "") {
      setErrors({ title: ["Title cannot be blank."] });
      return; 
    }

    setLoading(true); 
    setErrors({}); 
    try {
      const formData = new FormData(e.target);
      const data = { doc: {} };
      for (const [key, value] of formData.entries()) {
        data.doc[key] = value;
      }
      data.authenticity_token = csrfToken();

      const response = await networkService("/kdfs.json", "POST", data);

      if (response.status === 201) {
        window.location.href = `/kdfs/${response.data.id}`;
      } else {
        setErrors({ ...response.data });
      }
    } catch (error) {
      console.error("Error submitting KDF:", error);
      if (error.response && error.response.data) {
        setErrors({ ...error.response.data });
      } else {
        setErrors({ general: ["An unexpected error occurred. Please try again."] });
      }
    } finally {
      setLoading(false); 
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      const form = e.target?.form;
      if (form) {
        handleSubmit({ preventDefault: () => {}, target: form });
      }
    }
  };

  return (
    <Row>
      <Col md={12}>
        {/* <div className="m-3"> */}
          <div className="new-kdf">
            <form onSubmit={handleSubmit}>
              <input type="hidden" name="user_id" value={props?.user_id} />
              <Input
                type="text"
                placeholder="Enter a title for your new KDF.."
                name="title"
                label="Enter a title for your new KDF:"
                autoFocus
                style={{ borderColor: "#294561" }}
                onChange={(e) => {
                  setFormDocTitle(e.target.value);
                  if (errors.title) {
                    setErrors((prevErrors) => {
                      const newErrors = { ...prevErrors };
                      delete newErrors.title;
                      return newErrors;
                    });
                  }
                }}
                value={formDocTitle}
                onKeyDown={handleKeyDown}
              />
              {Object.keys(errors || {}).map((key) => {
                const message = Array.isArray(errors[key]) ? errors[key][0] : errors[key];
                return (
                  <p key={key} className="back-alert p-2 my-3 text-white">
                    {message}
                  </p>
                );
              })}
              <div className="new-kdf-btn-group">
                <Button
                  classList={"alert"}
                  addonClass=""
                  text={"Cancel"}
                  onClick={() => (window.location = "/kdfs")}
                />
                <Button
                  classList={
                    formDocTitle.trim() === "" || loading ? "disabled" : "success"
                  }
                  disabled={formDocTitle.trim() === "" || loading}
                  addonClass=""
                  text={loading ? "Loading..." : `Continue`}
                  type="submit"
                  variant="blue"
                />
              </div>
            </form>
          {/* </div> */}
        </div>
      </Col>
    </Row>
  );
};

export default CreateNewKdf;